import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookIcon
} from 'react-share';
import styled from 'styled-components';
import SmsSvg from '../../images/SmsSvg';
import HOC from '../HOC';

const ShareContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 200px;
  margin: 0 auto;
  transform: translateY(-17px)
`;

const SmsIconContainer = styled.a`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;  
  background-color: #2185D0;
  border-radius: 50%;
  width: 152px;
  height: 41px;
  margin-right: 5px;
`;

const RcForKidsDetails = () => {
  const { state } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div style={{ height: 'calc(100vh - 140px)' }}>
        <iframe
          style={{ transform: 'translateY(-22px)' }}
          type="application/pdf"
          scrolling="auto"
          title={state}
          src={`https://mozilla.github.io/pdf.js/legacy/web/viewer.html?file=${encodeURIComponent(state)}`}
          height="100%"
          width="100%"
        />
        <ShareContainer>
          <SmsIconContainer href={`sms:?&body=${state}`} target="_blank" rel="noreferrer">
            <SmsSvg />
          </SmsIconContainer>
          <EmailShareButton url={state} subject="Recycle Coach For Kids">
            <EmailIcon size={42} round bgStyle={{ fill: '#2185D0' }} />
          </EmailShareButton>
          <TwitterShareButton url={state} title="Recycle Coach For Kids">
            <TwitterIcon size={42} round bgStyle={{ fill: '#2185D0' }} />
          </TwitterShareButton>
          <FacebookShareButton quote="Recycle Coach For Kids" url={state}>
            <FacebookIcon size={42} round bgStyle={{ fill: '#2185D0' }} />
          </FacebookShareButton>
        </ShareContainer>
      </div>

    </>
  );
};

export default HOC(RcForKidsDetails);
